import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const PDPValuePropsModalV2 = t0 => {
  const $ = _c(2);
  const {
    description
  } = t0;
  if (!description) {
    return null;
  }
  let t1;
  if ($[0] !== description) {
    t1 = <div className="mt-4"><div dangerouslySetInnerHTML={{
        __html: description
      }} className="text-sm text-brand-lightest [&_p]:mb-4 [&_ul]:pl-5 [&_ul]:mb-4 [&_li]:mb-1" /></div>;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
PDPValuePropsModalV2.propTypes = {
  description: PropTypes.string
};
export default PDPValuePropsModalV2;